<!--
 * @Description: 报名成功信息页
 * @Author: 山淑兰
 * @Date: 2019-11-11 17:39:20
 * @LastEditTime: 2020-07-15 18:03:43
 * @LastEditors: 山淑兰
 -->
<template>
    <div id="hotelList">
        <Loading v-if="show"></Loading>
        <div class="hotelList_container">
            <header class="hotel-header">
                <div class="header-left" @click="goBack">
                    <img src="../../assets/return-white.png"> 
                </div>
                <div class="header-title">
                    订单详情
                </div>
                <div class="header-right">
                </div>
            </header>
            <div class="hotelList_content">
                <div class="order-state">
                    <span v-if="hotelRecord.state==0">预订成功</span>
                    <span v-if="hotelRecord.state==1">预订失败</span>
                </div>
                <div class="order-tips">
                    请携带有效身份证件办理入住
                </div>
                <div class="order-opt">
                    <!-- <span>修改订单</span> -->
                    <span v-if="hotelRecord.state==2">已取消</span>
                    <span v-else @click="goCancel(hotelRecord.hrcid)">取消订单</span>
                    <!-- <span class="fp" @click="goInvoice()">开发票</span> -->
                </div>
                <div class="order-hotel">
                    <div class="hotel-pic">
                        <img v-if="hotelRecord.Hotel_BasicinfoEntity.hotelRecord==''||hotelRecord.Hotel_BasicinfoEntity.hotelpic==null||!hotelRecord.Hotel_BasicinfoEntity.hotelpic" src="../../assets/hotel.png">
                        <img v-else :src="hotelRecord.Hotel_BasicinfoEntity.hotelpic">
                    </div>
                    <div class="hotel-desc" v-if="hotelRecord.Hotel_BasicinfoEntity">
                        <p class="hotel-name">{{hotelRecord.Hotel_BasicinfoEntity.hotellname}}</p>
                        <p><img src="../../assets/add1.png"> {{hotelRecord.Hotel_BasicinfoEntity.hoteladdress}}</p>
                    </div>
                </div>
                <div class="order-dateRange">
                    <img src="../../assets/rili.png"> 
                    {{changeDate(hotelRecord.Checkintime,8)}}<span>共{{hotelRecord.days}}晚</span>{{changeDate(hotelRecord.Checkouttime,8)}}
                </div>
                <div class="hotel-text">
                    <img src="../../assets/jiudian.png"> {{hotelRecord.showname}}，共{{hotelRecord.rescount}}间，可入住{{hotelRecord.canpeople}}人
                </div>
                <div class="guest-info">
                    <p><img src="../../assets/renwu.png"> {{hotelRecord.resname}}</p>
                    <p><img src="../../assets/dianhua.png"> {{hotelRecord.resphone}}</p>
                    <p><img src="../../assets/zaocan.png"> 
                        <span v-if="hotelRecord.isbreakfast==0">不含早餐</span>
                        <span v-if="hotelRecord.isbreakfast==1">含早餐</span>
                    </p>
                </div>
                <!-- <div class="hotel-fp">
                    如需要发票可向酒店索取(酒店提供普票、专票)
                </div>
                <div class="hotel-money">
                    金额：<span>￥{{hotelRecord.money}}</span>
                </div>
                <div class="order-btns">
                    <div class="order-btn">
                        <span v-if="hotelRecord.paystatus==0">支付</span>
                    </div>
                    <div class="order-btn">
                        <span @click="goBack">返回</span>
                    </div>
                </div> -->
                <div class="loading" v-if="loading">
                    <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="14px">加载中...</van-loading>
                </div>
                <div class="tips-box" v-if="tipsVisible">
                    <div class="tips-con">
                        <div class="tips-text">
                            确定取消该订单么？
                        </div>
                        <div class="tips-group">
                            <div class="tips-group-btn" @click="closeTips()">
                                取消
                            </div>
                            <div class="tips-group-btn" @click="sureTips()">
                                确定
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from '@components/Loading.vue'
import Footer from '@components/Footer.vue'
// import publicSignup from '../../lib/signUp.js'
import wxShare from '../../lib/wxShare.js'
export default {
    name: 'hotelOrderDetail',
    components: {
        Loading,
    },
    data() {
        return {
          publicSignup: {}, //通用js
          params: {
              m: '',
          },
          meetingInfo: '',
          show: false,
          loading: false,
          navShow: true,
          navhomeUrl: '',
          hotelRecord: [],
          //hotellname: '',
          hrcid: '',
          tipsVisible: false,
        }
    },
    created() {
        this.params = this.$route.query
        // this.publicSignup = new publicSignup()
        // console.log(this.publicSignup)
        let opt = { m: this.params.m }
        //this.initmeeting(opt)
        this.hotelOrder()
    },
    mounted() {
        //this.swiperInit()
        document.title = this.hotellname
    },
    methods: {
        //时间转换
        changeDate(date,num){
            if( date != '' && date != null && date){
                if( date.length == 16 ){
                    num = num
                }else if( date.length == 17 ){
                    num = num + 1
                }else if( date.length == 18 ){
                    num = num + 2
                }
                var dateNew = date.substring(0, num)
                return dateNew.replace(new RegExp("/","gm"),"-")
            }

        },
        // async initmeeting(opt) {
        //     this.show = true
        //     this.meetingInfo = await this.publicSignup.init(opt, this)
        //     if (this.meetingInfo.Code === 1000) {
        //         this.show = false
        //         if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
        //             this.navShow = false
        //         } else {
        //             this.navShow = true
        //             this.navhomeUrl = this.meetingInfo.HomeUrl
        //         }
        //     } else {
        //         this.$notify({
        //             massage: this.meetingInfo.Msg,
        //             type: 'danger',
        //             duration: '3000',
        //         })
        //     }
        // },
        /**
         * 初始化订单列表
         */
        async hotelOrder() {
            let opt = { hrcid: this.params.hrcid }
            try {
                this.loading = true
                let res = await this.$http.hotelOrderDetail(opt)
                console.log(res)
                if (res.Code === 1000) {
                    this.loading = false
                    this.hotelRecord = res.hotel_Hotel_Record
                    this.hotellname = this.hotelRecord.Hotel_BasicinfoEntity.hotellname
                    document.title = this.hotellname
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'primary',
                    })
                }
                
            } catch (err) {
                console.log(err)
            }
        },

        //微信分享
        async initShare(title, desc, link, imgUrl) {
            try {
                const headRes = await this.$http.csData({
                    url: encodeURIComponent(
                        window.location.href.replace(location.hash, '')
                    ),
                })
                console.log(headRes, 'headRes')
                const _Wx = new wxShare({
                    opt: headRes,
                })
                _Wx.ready().then((wx) => {
                  _Wx.share(title, desc, link, imgUrl)
                })
                //this.headRess = _Wx
            } catch (err) {
                console.log(err)
            }
        },
        //微信发票抬头
        // async invoice(){
        //     try {
        //         const headRes = await this.$http.csData({
        //             url: encodeURIComponent(
        //                 window.location.href.replace(location.hash, '')
        //             ),
        //         })
        //         //console.log(headRes, 'headRes')
        //         const _Wx = new wxShare({
        //             opt: headRes,
        //         })
        //         _Wx.ready().then((wx) => {
        //             _Wx.invoice('chooseInvoiceTitle',{ "scene":"1" }, function(res) {
        //                 console.log('res', res)
        //             })
        //         })
        //         //this.headRess = _Wx
        //     } catch (err) {
        //         console.log(err)
        //     }

        //     // window.WeixinJSBridge.invoke(
        //     //   'chooseInvoiceTitle',
        //     //   { "scene":"1" },
        //     //   function(res) {
        //     //     window.WeixinJSBridge.log(res.err_msg)
        //     //     console.log('res', res)
        //     //   }
        //     // )
        //     // const headRes = await this.$http.csData({
        //     //     url: encodeURIComponent(
        //     //         window.location.href.replace(location.hash, '')
        //     //     ),
        //     // })
        //     // const _Wx = new wxShare({
        //     //     opt: headRes,
        //     // })
        //     // console.log(_Wx)
        //     // _Wx.ready().then((wx) => {
        //     //     _Wx.invoice()
        //     //     console.log(wx)
        //     // })
        // },
        //取消订单
        goCancel(hrcid){
            this.tipsVisible = true
            this.hrcid = hrcid
        },
        closeTips(){
            this.hrcid = ''
            this.tipsVisible = false
        },
        sureTips(){
            this.hotelOrderCancel(this.hrcid)
        },
        async hotelOrderCancel(hrcid) {
            let opt = { hrcid: hrcid}
            try {
                let res = await this.$http.hotelOrderCancel(opt)
                console.log(res)
                if (res.Code === 1000) {
                    this.tipsVisible = false
                    this.$notify({
                        message: '取消成功',
                        type: 'primary',
                    })
                    this.hotelOrder()
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'danger',
                    })
                }
            } catch (err) {
                console.log(err)
            }
        },
        //开发票
        goInvoice(){
            const params = {
                m: this.params.m
            }
            this.$router.push({
                path: '/hotelInvoice',
                query: params,
            })
        },
        goBack(){
            // this.$router.push({
            //     path: '/hotelList',
            //     query: {
            //         m: this.params.m,
            //     }
            // })
            this.$router.go(-1);
        },
    },
}
</script>
<style lang="scss" scoped>
    .hotel-header{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 80px;
        background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1e5fa8 100%);
        display: flex;
        align-items: center;
        .header-left,
        .header-right{
            width: 100px;
            text-align: center;
            img{
                width: 40px;
                height: 40px;
            }
        }
        .header-title{
            flex: 1;
            text-align: center;
            font-size: 30px;
            color: #fff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .hotelList_content{
        padding: 90px 0 20px;
        background: #ffffff;
        .order-state{
            font-size: 50px;
            padding: 10px 20px;
        }
        .order-tips{
            padding: 0 20px;
            color: #f56c6c;
            font-size: 26px;
        }
        .order-opt{
            padding: 10px 20px 0;
            display: flex;
            span{
                padding: 5px 15px;
                border: 1px solid #e2e8f0;
                border-radius: 10px;
                font-size: 28px;
                color: #1e293b;
                margin-right: 15px;
            }
            span.fp{
                color: #3b82f6;
            }
        }
        .order-hotel{
            padding: 20px;
            display: flex;
            margin-top: 20px;
            background: #f8fafc url(../../assets/map.png) no-repeat bottom right;
            background-size: 594px auto;
            .hotel-pic{
                width: 150px;
                height: 150px;
                border-radius: 10px;
                overflow: hidden;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover
                }
            }
            .hotel-desc{
                flex: 1;
                padding-left: 20px;
                p {
                    color: #1e293b;
                    font-size: 26px;
                    img {
                        width: 26px;
                        height: 19px;
                        vertical-align: 2px;
                    }
                }
                .hotel-name{
                    font-size: 30px;
                    margin-bottom: 5px;
                    color: #1e293b;
                    font-weight: bold;
                }
            }
        }
        .order-dateRange{
            padding: 0 20px;
            font-size: 32px;
            color: #1e293b;
            margin-top: 15px;
            img {
                width: 30px;
                height: 30px;
                vertical-align: -4px;
            }
            span{
                font-size: 26px;
                border: 1px solid #e2e8f0;
                padding: 0 20px;
                margin: 0 15px;
                border-radius: 30px;
            }
        }
        .hotel-text{
            padding: 0 20px;
            font-size: 30px;
            color: #1e293b;
            margin-top: 10px;
            border-top: 1px solid #e2e8f0;
            padding-top: 15px;
            img {
                width: 30px;
                height: 30px;
                vertical-align: -4px;
            }
        }
        .guest-info{
            padding: 0 20px 10px;
            margin-top: 15px;
            border-bottom: 1px solid #e2e8f0;
            p{
                font-size: 28px;
                padding: 5px 0;
                margin-bottom: 10px;
                img {
                    width: 30px;
                    height: 30px;
                    vertical-align: -4px;
                    margin-right: 5px;
                }
            }
        }
        .hotel-fp{
            border-top: 1px solid #e2e8f0;
            padding: 20px;
            font-size: 32px;
        }
        .hotel-money{
            border-top: 1px solid #e2e8f0;
            padding: 20px;
            font-size: 32px;
            span{
                color: #f56c6c;
            }
        }
        .order-btns{
            display: flex;
            margin-top: 15px;
            div{
                flex: 1;
                span{
                    display: block;
                    width: 200px;
                    height: 50px;
                    text-align: center;
                    line-height: 50px;
                    font-size: 28px;
                    margin: 0 auto;
                    border: 1px solid #e2e8f0;
                    border-radius: 30px;
                    background: #ffffff;
                }
            }
        }
    }
    .tips-box{
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 999;
        background: rgba(0,0,0,.5);
        .tips-con{
            position: absolute;
            width: 70%;
            height: 200px;
            background: #ffffff;
            top: 50%;
            left: 50%;
            z-index: 1000;
            transform: translate(-50%,-50%);
            font-size: 30px;
            text-align: center;
            border-radius: 20px;
            overflow: hidden;
            .tips-text{
                height: 110px;
                line-height: 110px;
            }
            .tips-group{
                display: flex;
                height: 90px;
                border-top: 1px solid #e2e8f0;
                >div{
                    flex: 1;
                    line-height: 90px;
                }
                >div:last-child{
                    background: #3b82f6;
                    color: #fff;
                }
            }
        }
    }
</style>
<style type="text/css">
    /*.van-notify{
        padding: 25px 10px;
        font-size: 14px;
    }*/
</style>